import { useState, useEffect } from "react";
import getDecodedToken from "services/getDecodedToken";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import {
  PageContainer, PremiumCard, Button, EmptyState, LoadingState,
} from "components/ui";

const IconDownload = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

const Historique = () => {
  const axiosPrivate = useAxiosPrivate();
  const [email, setEmail] = useState();
  const [id, setId] = useState();
  const [history, setHistory] = useState();
  const [loading, setLoading] = useState(true);

  const fetchMyHistory = async () => {
    setLoading(true);
    try {
      const response = await axiosPrivate.get(`/history/${id}/myHistory`);
      setHistory(response.data);
    } catch (_) {
      console.error("history not found");
    } finally {
      setLoading(false);
    }
  };
  const fetchUserByEmail = async (email) => {
    try {
      const response = await axiosPrivate.get("/user/getU", { params: { email } });
      setId(response.data.user_id);
    } catch (_) {
      console.error("User not found");
    }
  };

  const exportPdf = async () => {
    try {
      const response = await axiosPrivate.get(`history/${id}/export`, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `history_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (_) {
      console.error("error occurred");
    }
  };

  useEffect(() => {
    const decoded = getDecodedToken();
    if (decoded) setEmail(decoded.sub);
    if (email) fetchUserByEmail(email);
  }, [email]);
  useEffect(() => { if (id) fetchMyHistory(); }, [id]);

  return (
    <PageContainer narrow>
      <PremiumCard
        title="Your history"
        subtitle="Activity log on your account"
        actions={
          <Button variant="secondary" size="sm" leftIcon={<IconDownload />} onClick={exportPdf}>
            Export PDF
          </Button>
        }
      >
        {loading ? (
          <LoadingState label="Loading history…" />
        ) : !history || history.length === 0 ? (
          <EmptyState title="No history found" description="Activity entries will appear here." />
        ) : (
          <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: 10 }}>
            {history.map((item, i) => (
              <li
                key={i}
                style={{
                  background: "var(--surface-muted)",
                  border: "1px solid var(--border-subtle)",
                  borderRadius: 12,
                  padding: 16,
                  display: "grid", gap: 6,
                  transition: "transform var(--duration-fast) var(--ease)",
                }}
              >
                <div style={{ fontSize: 14, color: "var(--text-body)" }}>
                  <strong className="t-accent" style={{ marginRight: 8 }}>Details:</strong>
                  {item.details || "No description available"}
                </div>
                <div className="t-body-sm t-muted">
                  <strong className="t-accent" style={{ marginRight: 8 }}>Date:</strong>{item.date}
                </div>
              </li>
            ))}
          </ul>
        )}
      </PremiumCard>
    </PageContainer>
  );
};

export default Historique;
